export function getSimpleToken(){
   return 'HsuuWOCYL2An7WtKheoiD5HE0UhEMAOD';
}

export default { getSimpleToken };




// WEBPACK FOOTER //
// ./js/core/core.js